/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DropDownDto } from '../../models/drop-down-dto';

export interface ApiEmployeeDropdownOptionsGet$Params {
  'api-version'?: string;
}

export function apiEmployeeDropdownOptionsGet(http: HttpClient, rootUrl: string, params?: ApiEmployeeDropdownOptionsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DropDownDto>>> {
  const rb = new RequestBuilder(rootUrl, apiEmployeeDropdownOptionsGet.PATH, 'get');
  if (params) {
    rb.query('api-version', params['api-version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<DropDownDto>>;
    })
  );
}

apiEmployeeDropdownOptionsGet.PATH = '/api/employee/dropdown-options';
